import { useLocation } from 'react-router'

import EntityBlock from 'components/staticpages/blocks/entityblock'

// Types
import { NormalizedDiscoverEntity } from 'types'

import { Shelf, Carousel, useMaxWidth, Section } from '@tracklib/kit'

type EntitiesProps = {
  value: {
    items: Array<{
      entity: NormalizedDiscoverEntity
      url: string
      type: string
      title: string
      mobileImage: number
      background_color: string
      background_image: number
      mobile_background_image: number
      button_text: string
    }>
    items_to_show: number
    heading?: string
    subheading?: string
    heading_mobile?: string
    show_more_text?: string
    show_more_text_mobile?: string
    show_more_url?: string
    hide_label?: boolean
    hide_title?: boolean
    hide_description?: boolean
    hide_play?: boolean
    carousel?: boolean
    identifier?: string
  }
}

const Entities = ({
  value: {
    items,
    items_to_show,
    heading,
    subheading,
    heading_mobile,
    show_more_text,
    show_more_text_mobile,
    show_more_url,
    hide_label,
    hide_title,
    hide_description,
    hide_play,
    carousel,
    identifier,
  },
}: EntitiesProps): JSX.Element => {
  const { pathname } = useLocation()
  const isSmall = useMaxWidth()
  const Element = carousel ? Carousel : Shelf
  const showArrows = items.length > +items_to_show

  const getSize = () => {
    if (carousel) {
      return 1
    }
    if (showArrows) {
      return +items_to_show
    }
    return items.length
  }

  if (!items.length) {
    return <Section>No results found for {heading}</Section>
  }

  return (
    <Element
      heading={isSmall && heading_mobile ? heading_mobile : heading}
      subheading={subheading}
      linkText={isSmall && show_more_text_mobile ? show_more_text_mobile : show_more_text}
      linkUrl={show_more_url}
      extraPad={!pathname.startsWith('/inspiration') && !pathname.startsWith('/collections')}
      showMoreDatatesting="showMoreDatatesting"
      arrows={items.length > +items_to_show}
    >
      {items.map((x, i) => {
        const { type, value } = x.entity ? x.entity[0] : x
        return (
          <Element.Item key={`${type}-${value}-${String(i)}`} color={x.background_color} size={getSize()}>
            <EntityBlock
              item={x}
              key={String(i)}
              size={getSize()}
              hideLabel={hide_label}
              hideTitle={hide_title}
              hideDescription={hide_description}
              hidePlay={hide_play}
              identifier={identifier || heading || 'no identifier'}
            />
          </Element.Item>
        )
      })}
    </Element>
  )
}

export default Entities
